import { useContext } from 'react'
import { EngagementContext } from 'src/context/engagement'
import { GlobalContext } from 'src/context/global'
import {
  BorderStyleSelectMultiple,
  BorderStyleSelectRow,
  BorderStyleDate,
  TopFilterBox,
} from 'src/components'
import dayjs from 'dayjs'

const typeOptions = [
  {
    label: 'Overall',
    value: 'overall',
  },
  {
    label: 'Interstitial',
    value: 'interstitial',
  },
  {
    label: 'Banner',
    value: 'banner',
  },
  {
    label: 'Rewarded Video',
    value: 'reward_video',
  },
  {
    label: 'Native Ads',
    value: 'nativeads',
  },
  {
    label: 'App Open',
    value: 'openads',
  },
  {
    label: 'Rewarded Interstitial',
    value: 'rewardinter',
  },
]
const platformOptions = [
  {
    label: 'iOS',
    value: 'iOS',
  },
  {
    label: 'Android',
    value: 'android',
  },
]
const TopFilterView = (props: any): JSX.Element => {
  const { state, dispatch, searchData } = useContext(EngagementContext)
  const { state: globalState } = useContext(GlobalContext)

  const timeChange = (dateRange: any[], timeShow: string) => {
    dispatch({
      type: 'time',
      payload: dateRange,
    })

    dispatch({
      type: 'timeShow',
      payload: timeShow,
    })
  }
  const reset = () => {
    timeChange(
      [
        dayjs().subtract(1, 'week').format('YYYY-MM-DD'),
        dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
      ],
      'last_week'
    )
    dispatch({
      type: 'type',
      payload: 'overall',
    })
    dispatch({
      type: 'gameSelect',
      payload: [],
    })
    dispatch({
      type: 'country',
      payload: [],
    })
    dispatch({
      type: 'platform',
      payload: [],
    })
    dispatch({
      type: 'resetIndex',
      payload: state.resetIndex + 1,
    })
  }
  // returns
  return (
    <TopFilterBox
      ContentView={
        <>
          <BorderStyleDate
            label="Dates"
            timeShow={state.timeShow}
            value={state.time}
            onChange={timeChange}
            onTriggerFilter={searchData}
          />
          <BorderStyleSelectMultiple
            label="Apps"
            valueKey="app_key"
            labelKey="name"
            placeholder="Apps"
            value={state.gameSelect}
            onChange={(row: any) => {
              dispatch({
                type: 'gameSelect',
                payload: row,
              })
            }}
            options={globalState.gameOption}
            onTriggerFilter={searchData}
          />
        </>
      }
      PopoverView={
        <>
          <BorderStyleSelectRow
            width="100%"
            label="Ad Type"
            placeholder="Ad Type"
            value={{ value: state.type }} // 接收对象，所以讲state.type包装为对象
            onChange={(row: any) => {
              dispatch({
                type: 'type',
                payload: row.value,
              })
            }}
            options={typeOptions}
            onTriggerFilter={searchData}
          />
          <BorderStyleSelectMultiple
            width="100%"
            label="Countries"
            valueKey="code"
            labelKey="name"
            placeholder="Countries"
            value={state.country}
            onChange={(row: any) => {
              dispatch({
                type: 'country',
                payload: row,
              })
            }}
            options={globalState.countryOption}
            onTriggerFilter={searchData}
          />
          <BorderStyleSelectMultiple
            width="100%"
            label="Platform"
            placeholder="Platform"
            value={state.platform}
            showSearch={false}
            onChange={(row: any) => {
              dispatch({
                type: 'platform',
                payload: row,
              })
            }}
            options={platformOptions}
            onTriggerFilter={searchData}
          />
        </>
      }
      reset={reset}
      search={() => {
        searchData()
      }}
    />
  )
}

export default TopFilterView
